<fieldset>
	<br/>
	<app-add-maslol *ngFor="let maslol of internalMaslolArray.controls; let i=index" [index]="i" [maslol]="maslol" 
	 (removed)="internalMaslolArray.removeAt($event)" [qID]="qID" [displayErrors]="displayErrors" [titles]="titles" (change)="emitMaslolChanges($event)"
	 [ph]="ph" [displayX]="internalMaslolArray.length>1">
	</app-add-maslol>
</fieldset>

<div class="d-flex justify-content-center text-center">
	<div *ngIf="internalMaslolArray.length > 0 && internalMaslolArray.length < maxMaslolArrayLength" class="m-add-line-btn" (click)="addMaslol()" 
		role="button" tabindex="0" 
		(keypress)="simulateClick($event)">
		<span>{{buttons[0]|translate}}</span>
	</div>
	<div *ngIf="internalMaslolArray.length === 0" 
	class="m-add-line-btn" (click)="addMaslol()" 
	role="button" tabindex="0" 
	(keypress)="simulateClick($event)">
		<i class="fa fa-plus" aria-hidden="true"></i>
		<span>{{buttons[0]|translate}}</span>
	</div>
</div>
<br/>



// WEBPACK FOOTER //
// ./src/app/internal-maslol-array/internal-maslol-array.component.html